import { Box, Button, ButtonAppearance, ButtonComponentProps, ButtonSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { formFooterHeight, fullHDFormWidth, fullHDScreenWidth } from '~/utilities';

interface ButtonProps {
  secondary?: boolean;
}

export const FooterStyled = styled(Box).attrs({
  px: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  height: ${formFooterHeight}px;
   {
    /* Toast content is going behind the footer. Fix toast and enable z-index */
  }
  /* z-index: 1; */
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.16);
`;

export const ContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'flex-end' },
})<{ uiType: 'Form' | 'Grid' }>`
  width: 100%;
  @media only screen and (min-width: ${fullHDScreenWidth}) {
    ${({ theme, uiType }) => css`
      padding-right: ${theme.spacings[500]};
      ${uiType === 'Form' && `width: ${fullHDFormWidth}`}
    `}
  }
`;

export const ButtonStyled = styled(Button).attrs<ButtonProps>((props) => ({
  appearance: props.secondary ? ButtonAppearance.SECONDARY : ButtonAppearance.PRIMARY,
  size: ButtonSize.SMALL,
}))<ButtonComponentProps & ButtonProps>`
  ${({ theme, secondary }) => css`
    width: 100px;
    height: 36px;
    margin-left: ${!secondary && theme.spacings[400]};
    padding: 0 ${theme.spacings[500]};
    justify-content: space-evenly;
  `}
`;
